import { createApiAction } from '@app/packages/api/utils'
import type { ApiAccountIssue, ApiAccountIssueStep, ApiBill } from '@app/packages/api/v2/types/entities'
import type { GetAccountIssuesQuery } from '@app/packages/api/v2/types/params'
import { v2Path } from '@app/packages/api/v2/utils'

export const getAccountIssues = (query?: GetAccountIssuesQuery) =>
  createApiAction('getAccountIssues', dispatch =>
    dispatch<{ data: ApiAccountIssue[]; included?: (ApiAccountIssueStep | ApiBill)[] }>({
      method: 'GET',
      endpoint: v2Path('/api/v2/account_issues', query),
    })
  )
